import { Paper } from "@mui/material"
import PesquisarOrdemServico from "./PesquisarOrdemServico/PesquisarOrdemServico"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { useContext, useEffect, useState } from "react"
import OrdemServicoTable from '../OrdemServicoTable/OrdemServicoTable'
import { showNotify } from '../../../Utils/Utils'
import { OrdemServicoContext } from '../../../Providers/OrdemServicoContext/OrdemServicoContext'
import { CondominiosContext } from '../../../Providers/CondominiosContext/CondominiosContext'

const ListarOrdemServico = () => {
    const { addRoute } = useContext(WebSocketContext)
    const { buscarOrdensServico } = useContext(OrdemServicoContext)
    const { activeCond } = useContext(CondominiosContext)

    const [ordensServico, setOrdensServico] = useState([])

    addRoute("buscarOrdensServico", (msg) => {
        const { status, message, ordensServico } = msg.data

        if (status === 'error' || !status) {
            showNotify('error', message)
        }

        setOrdensServico(ordensServico || [])
    })

    useEffect(() => {
        buscarOrdensServico(activeCond.id_central)
    }, [activeCond.id_central])

    return (
        <Paper sx={{
            backgroundColor: '#D9D9D9',
            padding: '10px',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            overflowY: 'scroll'
        }}>
            <PesquisarOrdemServico />
            <OrdemServicoTable dados={ordensServico}/>
        </Paper>
    )
}

export default ListarOrdemServico
